module.exports = __webpack_public_path__ + "img/erasmusPlus.7a4e9472.png";